import { LanguageCodeEnum } from "../saleor-graphql";
import { IChannel } from "./types";

export const localeForChannel = (
  channel: IChannel,
  locale: string | LanguageCodeEnum
) => {
  return locale.toUpperCase() as LanguageCodeEnum;
};
